import { useEffect, useRef, useState } from "react";

// The press that selects the video must not wake the player, or the iframe takes over the drag
// that press may start. Only a click on a video that was already selected hands the mouse to the player.
const usePlayerActivation = (selected: boolean) => {
	const [isActive, setIsActive] = useState(false);
	const wasSelectedRef = useRef(false);

	useEffect(() => {
		if (!selected) setIsActive(false);
	}, [selected]);

	return {
		playerState: isActive ? "active" : "idle",
		onMouseDown: () => {
			wasSelectedRef.current = selected;
		},
		onClick: () => {
			if (wasSelectedRef.current) setIsActive(true);
		},
	};
};

export default usePlayerActivation;
